import { PopperProps, Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import { FixedWidthPopper } from '../popper/fixed-width-popper.component';

interface CustomTooltipProps extends TooltipProps {
  width?: string | number;
  popperProps?: Partial<PopperProps>;
}

export function Tooltip({ width, popperProps, ...props }: CustomTooltipProps) {
  // Set the defaults if they are not already set. If the width is not set, we will default to 320px
  const defaultProps = {
    ...popperProps,
    width: width ?? '320px',
    disablePortal: popperProps?.disablePortal ?? false,
    style: {
      ...popperProps?.style,
      zIndex: 10000 // Increase the z-index so that the tooltip is always on top of other elements
    },
    popperOptions: {
      ...popperProps?.popperOptions,
      strategy: 'fixed' as const, // Ensures the tooltip is positioned relative to the viewport
      // Popper v2 takes modifiers as an array
      modifiers: [
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            boundariesElement: 'window',
            priority: ['left', 'right', 'top', 'bottom']
          }
        },
        {
          name: 'flip',
          enabled: true
        }
      ]
    }
  };

  return (
    <MuiTooltip
      {...props}
      slots={{
        popper: FixedWidthPopper
      }}
      slotProps={{
        popper: defaultProps
      }}
    />
  );
}
